
function Footer() {
    return (
        <div className="ftr-container">
            <span className="footer-text">Brought to you by Lewis L. Wood</span><br/>
            <span ><a href="http://nfbcs.lewislwood.com">http://nfbcs.lewislwood.com </a></span>

        </div>
    );
}

export default Footer;